<template>
	<footer class="probootstrap-footer probootstrap-bg">
		<div class="container">
			<div class="row">
				<div class="col-md-3 col-xs-12 ">
					<div class="probootstrap-footer-widget">
						<h3></h3>
						<ul class="probootstrap-footer-social">
							<li><a class="footer_icon" href="javascript:void(0)"><img
										src="../assets/common/footer1.png" />173-7675-1232</a></li>
							<li><a class="footer_icon" href="javascript:void(0)"><img
										src="../assets/common/footer2.png" />business@colofoo.com</a></li>
						</ul>
					</div>
				</div>
				<div class="col-md-2 col-xs-12 ">
					<div class="probootstrap-footer-widget">
						<h3>产品</h3>
						<ul class="probootstrap-footer-social">
							<li><a href="/wear">智能穿戴健康</a></li>
							<li><a href="https://www.colofoo.com/recovery.html" target="_blank">心脏康复系统</a></li>
							<li><a href="https://www.colofoo.com/huacai.html" target="_blank">数字保健</a></li>
							<li><a href="https://www.eachdoctor.com/" target="_blank">智能医疗系统</a></li>
						</ul>
					</div>
				</div>
				<div class="col-md-2 col-xs-12 ">
					<div class="probootstrap-footer-widget">
						<h3>合作</h3>
						<ul class="probootstrap-footer-social">
							<li><a href="https://www.colofoo.com/rest.html" target="_blank">智慧养老</a></li>
							<li><a href="https://www.colofoo.com/coop.html" target="_blank">医疗健康</a></li>
							<li><a href="https://www.colofoo.com/fire.html" target="_blank">消防安全监测</a></li>
							<li><a href="https://www.colofoo.com/bus.html" target="_blank">交通行业</a></li>
							<li><a href="https://www.colofoo.com/pharmacy.html" target="_blank">诊所药店</a></li>
						</ul>
					</div>
				</div>
				<div class="col-md-2 col-xs-12 " v-if="show">
					<div class="probootstrap-footer-widget">
						<h3>健康</h3>
						<ul class="probootstrap-footer-social">
							<li><a href="https://www.colofoo.com/xtjk/index.html" target="_blank">健康资讯</a></li>
						</ul>
					</div>
				</div>
				<div class="col-md-2 col-xs-12 ">
					<div class="probootstrap-footer-widget probootstrap-footer-widget-st">
						<span><img src="../assets/common/xintai.png" alt="">
							<div>扫码关注我们</div>
						</span>
						<span><img src="../assets/common/yuncode.png" alt="">
							<div>商务洽谈</div>
						</span>
					</div>
				</div>
			</div>
			<div class="">
				<p class="st_links">友情链接： <a href="http://www.nhc.gov.cn/" target="_blank">中华人民共和国国家卫生健康委员会</a>
					<a href="http://www.cha-china.org/" target="_blank">中国健康管理协会</a>
					<a href="http://www.301hospital.com.cn/" target="_blank">中国人民解放军总医院</a>
					<a href="http://www.szjkgl.net/" target="_blank">深圳市健康管理协会</a>
				</p>
			</div>
			<!-- END row -->
		</div>
		<div class="line"></div>
		<div class="probootstrap-copyright">
			<div class="container">
				<p>©Copyright 2020 All Rights Reserved 深圳市心奓体泰智能设备有限责任公司</p>
				<p>ICP备案： <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2023010584号-1</a>
					<!-- <a href="https://amr.sz.gov.cn/xzsp/xzsp-company-pc/#/info-disc-detail?certificatInsId=c34104526bc04672ab262fdf9b0e82dc&type=10&dataMasking=0"
						target="_blank">粤深药监械经营许20230168号</a>
					<a v-if="show2" href="https://www.colofoo.com/certificate.html" target="_blank">
						互联网药品信息服务资格证编号（粤）-经营性-2021-0221</a> -->
				</p>
			</div>
		</div>
	</footer>
</template>
<script>
	export default {
		name: "footerBar",
		data() {
			return {
				show: true,
				show2: false,
				type: 1
			}
		},
		mounted() {
		
		},
		methods: {}
	}
</script>
<style scoped>
	.footer_icon img {
		height: 24px;
		margin-right: 10px;
	}

	.footer_icon {
		font-size: 20px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 28px;
	}

	.QQ {
		width: 270px;
		height: 40px;
		background: #377CF7;
		border-radius: 5px;
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 22px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>